import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import {
    getMemoRandumList,
    getMe,
} from '../util/api'

function readStoredUser() {
    try {
        return JSON.parse(localStorage.getItem('user') || 'null')
    } catch (_) {
        return null
    }
}

const store = new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    user: readStoredUser(),
    showWarning: false
  },
  mutations: {
    setAuth(state, payload) {
      state.token = payload.token || ''
      state.user = payload.user || null
      if (payload.token) {
        localStorage.setItem('token', payload.token)
      } else {
        localStorage.removeItem('token')
      }
      if (payload.user) {
        localStorage.setItem('user', JSON.stringify(payload.user))
      } else {
        localStorage.removeItem('user')
      }
    },
    clearAuth(state) {
      state.token = ''
      state.user = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    },
    updateShowWarning(state, payload) {
      state.showWarning = payload.showWarning;
    }
  },
  actions: {
    refreshUser({ commit, state }) {
      if (!state.token) {
        return Promise.resolve(null)
      }
      return getMe().then((res) => {
        const data = res.data
        if (data.code === 0 && data.user) {
          commit('setAuth', {
            token: state.token,
            user: data.user,
          })
          return data.user
        }
        commit('clearAuth')
        return null
      }).catch(() => {
        commit('clearAuth')
        return null
      })
    },
    updateShowWarning({ commit, state }) {
        getMemoRandumList({ type: 0 }).then((res) => {
            const peopleMapping = {
                "0": "爸爸",
                "1": "妈妈",
                "2": "奶奶",
            }
            const showWarning = res.data.map((item) => {
                return {
                    ...item,
                    remindPeople: item.remindPeople || "[\"0\",\"1\",\"2\"]",
                }
            }).some((item) => {
                const role = state.user?.display_name
                if (role) {
                    return JSON.parse(item.remindPeople).some((people) => peopleMapping[people] === role)
                }
                return true
            });
            commit('updateShowWarning', {showWarning});
        })
      
    }
  }
});

export default store;
